import script from "./CertificationsAndDisbursements.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificationsAndDisbursements.vue?vue&type=script&setup=true&lang=ts"

import "./CertificationsAndDisbursements.vue?vue&type=style&index=0&id=087acb18&scoped=true&lang=css"
import "@/assets/css/certifications/certification-form.css?vue&type=style&index=1&id=087acb18&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-087acb18"]])

export default __exports__